import createComponentPreset from "../../../../../fabrics/createComponentPreset";
import { createDisplayNameForMediaElement } from "../../../utils/getDisplayName";
import { createTestIdForMediaElement } from "../../../utils/getTestId";
import Addon from "../Addon/MediaAddon";

import classes from "./MediaTopLeftAddon.styl";

const TOP_LEFT_ADDON_DISPLAY_NAME = "TopLeftAddon";
const TOP_LEFT_ADDON_TEST_ID = createTestIdForMediaElement(
    TOP_LEFT_ADDON_DISPLAY_NAME,
);

/**
 * @deprecated
 * Используйте вместо этого компонента UniBoxAdditional / UniBoxMain
 */
export const TopLeftAddon = createComponentPreset(
    TOP_LEFT_ADDON_DISPLAY_NAME,
    Addon,
    {
        className: classes.addon,
        "data-tsid": TOP_LEFT_ADDON_TEST_ID,
    },
);

TopLeftAddon.displayName = createDisplayNameForMediaElement(
    TOP_LEFT_ADDON_DISPLAY_NAME,
);

export default TopLeftAddon;
